import apiRequest from './apiClient';

/**
 * Изменить alias (имя/пометку) члена организации.
 * PATCH /api/members/{memberId}/alias
 * body: { alias, eventPublicId? }  → MemberResponse
 * Пустая строка/null очищает alias.
 * eventPublicId передаётся для проверки роли ATTENDANCE (правка из контекста события);
 * владельцу организации он не нужен.
 */
export const updateMemberAlias = (memberId, alias, eventPublicId = null) =>
  apiRequest(`/api/members/${memberId}/alias`, {
    method: 'PATCH',
    body: JSON.stringify({ alias, eventPublicId }),
  });
